<h5 class="mat-dialog-title">Unsaved Changes
    <button class="mat-icon-button mat-dialog-close" (click)="onCloseClick()" >
       <span class="close">&times;</span> 
    </button>
</h5>
<div class="mat-dialog-content">
    Save changes before {{data.message}} changes will cause any unsaved changes to be discarded
</div>
<div class="mat-dialog-actions">
  
    <button class="glossy-button" mat-button (click)="onSaveClick()">Save</button>
    <button class="glossy-button" mat-button (click)="onDiscardClick()">Discard</button>
    <button class="glossy-button" mat-button (click)="onRefreshCancelClick()">Cancel</button>
</div>